export const API_LOCAL_URL = "http://localhost:3001";
export const API_PROD_URL = "https://apiautorizacao.cieemg.org.br";

const isDevEnvironment = () => {
  if (process.env.NODE_ENV === "development") return true;
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "[::1]" ||
    /^192\.168\./.test(host) ||
    /^10\./.test(host) ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(host) ||
    host.endsWith(".local")
  );
};

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (isDevEnvironment() ? API_LOCAL_URL : API_PROD_URL);

/**
 * Endpoints consumidos pela aplicação.
 *
 * Mantém compatibilidade com o formato já usado pelas páginas (callbacks
 * recebem o id) e adiciona endpoints auxiliares consumidos pela página
 * de Acompanhamento, alinhando a nomenclatura à API
 * api-autorizacao-estagio-aprendiz e espelhando os padrões usados no
 * projeto CadastroEmpresa.
 */
export const API_ENDPOINTS = {
  dashboard: `${API_BASE_URL}/dashboard`,
  tce: `${API_BASE_URL}/tce`,
  tca: `${API_BASE_URL}/tca`,
  tca_empregador: `${API_BASE_URL}/tca-empregador`,
  tce_upload: `${API_BASE_URL}/upload`,
  tca_upload: `${API_BASE_URL}/upload`,
  tce_empresa_autorizacao: (empresaId) =>
    `${API_BASE_URL}/tce/empresa/${empresaId}/autorizacao`,
  tca_empresa_autorizacao: (empresaId) =>
    `${API_BASE_URL}/tca/empresa/${empresaId}/autorizacao`,
  tca_id_aprovar: (id) => `${API_BASE_URL}/tca/${id}/aprovar`,
  tca_id_recusar: (id) => `${API_BASE_URL}/tca/${id}/recusar`,
  // Endpoint dedicado de acompanhamentos do usuário logado.
  // ATUALIZADO 2026-09-25: o backend consolidou as listas TCE + TCA +
  // TCA Empregador em uma única rota agregada `/acompanhamentos/me`
  // que devolve cada item já com etapa_atual, total_etapas,
  // status_label, cor, _origem e tipo_programa. O front passa a
  // consumir ESTE endpoint e deixa de derivar o programa pelo JWT
  // (cada item declara o próprio tipo_programa).
  //
  // A rota legada `/tca-empregador/acompanhamentos/me` continua
  // listada em `tca_empregador_acompanhamentos_me_legacy` para
  // eventual fallback enquanto o ambiente de homologação antigo
  // existir - o service decide a ordem.
  acompanhamentosMe: `${API_BASE_URL}/acompanhamentos/me`,
  tca_empregador_acompanhamentos_me_legacy: `${API_BASE_URL}/tca-empregador/acompanhamentos/me`,
  // Endpoint detalhado de status: devolve etapa_atual, label, cor, ultimo_evento
  // e o historico JSON interno do tca_empregador. Usado pelo modal de detalhe.
  tca_empregador_status_completo: (id) =>
    `${API_BASE_URL}/tca-empregador/${id}/status-completo`,
  inicial_tokens: `${API_BASE_URL}/tokens`,
  filial_id: (id) => `${API_BASE_URL}/filiais/${id}`,
  filial_update: (id) => `${API_BASE_URL}/filiais/${id}`,
  filial_list: `${API_BASE_URL}/filiais`,
  // Histórico de eventos do processo (auditoria).
  historico_eventos: `${API_BASE_URL}/historico-eventos`,
  // Busca interna de empresa (uso exclusivo de colaboradores CIEE:
  // SEOPE/SECEX/INFOR). Retorna, para cada empresa, quais formulários
  // (TCE / TCA / TCA Empregador) já existem vinculados + URL para abrir.
  empresa_buscar_interno: (campo, valor, limite = 20) =>
    `${API_BASE_URL}/api/empresa/buscar-interno?campo=${encodeURIComponent(
      campo,
    )}&valor=${encodeURIComponent(valor)}&limite=${limite}`,
};

// Re-exporta utilidades de sessão para evitar imports adicionais do
// frontend. Mantém as funções de auth acessíveis a partir do mesmo
// módulo já importado pelas páginas.
export { logout, limparSessaoEstudante, ESTUDANTE_STORAGE_KEYS } from "../frontend/js/auth.js";
